export const LEAVE_QUEUE_UPDATED_EVENT = "leave-queue-updated";

/** Pass via react-router location.state when opening the approval page from a notification. */
export const LEAVE_APPROVAL_NAV_STATE = { resetQueueFilters: true };

export function notifyLeaveQueueUpdated() {
  window.dispatchEvent(new CustomEvent(LEAVE_QUEUE_UPDATED_EVENT));
}
